"use client";

import { useMemo } from "react";
import Link from "next/link";
import SectionHeading from "@/components/SectionHeading";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import ProjectCard from "@/components/ProjectCard";
import { projectData } from "@/lib/projects";

const Projects = () => {
  // Only use the first 2 projects for the main page
  const featuredProjects = useMemo(() => projectData.slice(0, 2), []);
  
  return (
    <section id="projects" className="py-20 px-6 bg-muted/10">
      <div className="container max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-12">
          <SectionHeading title="Featured Projects" />
          <Button variant="outline" size="lg" asChild className="hidden md:flex">
            <Link href="/projects" className="group">
              View All Projects
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>
        
        <div className="space-y-6">
          {featuredProjects.map((project) => (
            <ProjectCard key={project.id} {...project} />
          ))}
        </div>
        
        <div className="flex justify-center mt-12 md:hidden">
          <Button variant="default" size="lg" asChild>
            <Link href="/projects" className="group">
              View All Projects
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
